import { Icons } from "@/components/elements/Icon/types";
import { RetrievalStage } from "@/types/api/retrievals";

export enum RetrievalEventTransKey {
  CREATED = "return_event_created",
  COLLECTED = "return_event_collected",
  CANCELLED = "return_event_cancelled",
}

export enum RetrievalStatusTransKey {
  RETURN_DATE = "overview_recent_return_date",
  RETURNED = "overview_recent_return_returned",
  CANCELLED = "overview_recent_return_cancelled",
  UNKNOWN = "unknown",
}

export interface RetrievalStatusInfo {
  statusKey: RetrievalStatusTransKey;
  eventKey: RetrievalEventTransKey;
  icon: Icons;
}

export const UNKNOWN_RETRIEVAL_STATUS_INFO: RetrievalStatusInfo = {
  statusKey: RetrievalStatusTransKey.UNKNOWN,
  eventKey: RetrievalEventTransKey.CANCELLED,
  icon: "info",
};

export const RETRIEVAL_STATUSES_INFO: Readonly<
  Record<RetrievalStage, RetrievalStatusInfo>
> = {
  [RetrievalStage.BOOKED]: {
    statusKey: RetrievalStatusTransKey.RETURN_DATE,
    icon: "truck",
    eventKey: RetrievalEventTransKey.CREATED,
  },
  [RetrievalStage.COLLECTED]: {
    statusKey: RetrievalStatusTransKey.RETURNED,
    icon: "truck",
    eventKey: RetrievalEventTransKey.COLLECTED,
  },
  [RetrievalStage.FAILED]: {
    statusKey: RetrievalStatusTransKey.CANCELLED,
    icon: "truck",
    eventKey: RetrievalEventTransKey.CANCELLED,
  },
  [RetrievalStage.UNKNOWN]: UNKNOWN_RETRIEVAL_STATUS_INFO,
};

export const RETRIEVAL_STATUS_ORDERED = [
  RetrievalStage.BOOKED,
  RetrievalStage.COLLECTED,
];
